import { render, staticRenderFns } from "./ADNewAssignmentItem.vue?vue&type=template&id=850231ba&scoped=true&"
import script from "./ADNewAssignmentItem.vue?vue&type=script&lang=js&"
export * from "./ADNewAssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./ADNewAssignmentItem.vue?vue&type=style&index=0&id=850231ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850231ba",
  null
  
)

export default component.exports